
export const colliders = new WeakMap();
